import { List } from '@eversports/klimt-primitives/legacy/List'
import Skeleton from '@eversports/klimt-primitives/legacy/Skeleton'

interface Props {
  numberOfSlotsToShow: number
}

const CourtSlotsSkeleton = ({ numberOfSlotsToShow }: Props) => {
  const skeletonSlots = [...Array(numberOfSlotsToShow)]
  return (
    <List sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', p: 0, gap: 2, marginRight: [0, 8] }}>
      {skeletonSlots.map((_slot, i) => (
        <Skeleton
          key={i}
          variant="rectangular"
          component="li"
          sx={{ width: ['72px', '60px'], height: ['21.5px', '37.5px'] }}
        />
      ))}
    </List>
  )
}

export default CourtSlotsSkeleton
